module.exports = __webpack_public_path__ + "media/images/star-pointer-d1fd6a0bd2c62ba2a295f2f9d65a53e2.svg";